<template>
    <div class="list-group-item" :class="rowClass">
        <div class="d-flex align-items-center">
            <span class="me-3" style="width:4em;">{{ index }}</span>
            <button type="button" class="btn btn-sm btn-primary" @click="toggle()" :disabled="noDiscard">
                <i v-if="discard" class="fa-solid fa-rotate-left"></i>
                <i v-else-if="noDiscard" class="fas fa-ban"></i>
                <i v-else class="fa-solid fa-trash-can"></i>
            </button>
            <div class="ms-3 flex-grow-1">
                <h6 class="text-primary m-0"><span class="student-name">{{ last_name }}, {{ first_name }}</span> ({{ grad_year }}) 
                    <span v-if="duplicate" class="bg-warning badge rounded-pill me-2">Duplicate</span>
                    <span v-if="invalid" class="bg-danger badge rounded-pill">Invalid</span>
                </h6>
                <span class="text-muted">{{ number }}</span>
            </div>
            <div>
                <a class="" data-bs-toggle="collapse" 
                :href="`#invalid-reason-collapse-${id}`" 
                v-if="invalid_reason"    
                aria-expanded="false" :aria-controls="`invalid-reason-collapse-${id}`">
                    <i class="fas fa-info-circle bg-white rounded"></i>
                </a>
            </div>
        </div>
        <div class="collapse mt-1" :id="`invalid-reason-collapse-${id}`">
            <ul class="list-group">
                <li v-for="r in reason" class="list-group-item"><i class="fas fa-exclamation-triangle text-danger"></i> {{ r }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            required: true,
        },

        student: {
            type: Object,
            default: function(data={}) {
                return {};
            }
        }
    },

    computed: {
        rowClass: function() {
            let cl = [];
            if (this.invalid) {
                cl.push('invalid');
            }

            if (this.duplicate) {
                cl.push('duplicate');
            }

            if (this.discard) {
                cl.push('discard');
            }

            return cl.join(' ');
        },

        noDiscard: function() {
            return Boolean(this.invalid) || Boolean(this.duplicate);
        },

        reason: function() {
            return this.invalid_reason.split(String.fromCharCode(31));
        },
    },

    data() {
        return {
            id: this.student.id ?? null,
            first_name: this.student.first_name ?? '',
            last_name: this.student.last_name ?? '',
            number: this.student.number ?? '',
            grad_year: this.student.grad_year ?? '',
            duplicate: this.student.duplicate ?? false,
            invalid: this.student.invalid ?? false,
            invalid_reason: this.student.invalid_reason ?? '',
            discard: this.student.discard ?? false,
        }
    },

    methods: {
        toggle: function() {
            this.$parent.isLoading = true;
            const data = { discard: !this.discard };
            axios
                .patch(`/api/admin/students/upload/${this.id}`, data)
                .then((response) => {
                    console.debug(response.data);
                    this.discard = response.data.discard;
                })
                .catch((error) => {
                    try {
                        console.warn(error.response.data.message);
                        alert(error.response.data.message);
                    } catch (error) {
                        alert('An unknown error occured');
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },
    },
}
</script>

<style scoped>
.invalid {
    background-color: mistyrose;
}
.duplicate {
    background-color: papayawhip;
}
.discard {
    background-color: lightgray;
}
.discard .student-name {
    text-decoration: line-through;
}
</style>